import React from "react"
import SbEditable from "storyblok-react"
import { useStaticQuery, graphql } from "gatsby"

import { StyledForm } from "../partials"
import { EventForm } from "./EventForm"
import { blokType, sbRichText } from "../../../types"

interface IEventFormBlok {
  formType: string
  fields: Array<any>
  campaignId?: string;
  multi_campaign: boolean;
  buttonLabel?: string
  privacy: sbRichText
  termsAndConditions?: string
  redirectType: string
  formLevelLink?: string
  fieldLevelDependency?: string
  fieldLevelDataSource?: string
}

interface IStoryblokEventForm {
  isDark?: boolean
  blok: IEventFormBlok & blokType
  campaign_id: Array<{ label: string; value: string }>
  campaign_id_label: string
  multi_campaign: boolean
}

export const StoryblokEventForm: React.FC<IStoryblokEventForm> = ({
  isDark,
  blok,
  campaign_id,
  campaign_id_label,
  multi_campaign
}) => {
  const formDataSources = useStaticQuery(graphql`
    query {
      allStoryblokDatasourceEntry(
        filter: { data_source: { regex: "/^forms*/" } }
      ) {
        edges {
          node {
            id
            name
            value
            data_source
          }
        }
      }
    }
  `)

  const formRedirects = formDataSources?.allStoryblokDatasourceEntry?.edges.filter(
    (o: any) => o.node.data_source === blok?.fieldLevelDataSource
  )

  return (
    <SbEditable content={blok}>
      <StyledForm>
        {blok.formType === "EVSU" && (
          <EventForm
            multi_campaign={multi_campaign}
            blok={blok}
            isDark={isDark}
            redirects={formRedirects}
            campaign_id_options={campaign_id}
            campaign_id_label={campaign_id_label}
          />
        )}
      </StyledForm>
    </SbEditable>
  )
}
